import { render, staticRenderFns } from "./LayoutAdmin.vue?vue&type=template&id=ebbe6b1e&scoped=true&"
import script from "./LayoutAdmin.vue?vue&type=script&lang=js&"
export * from "./LayoutAdmin.vue?vue&type=script&lang=js&"
import style0 from "./LayoutAdmin.vue?vue&type=style&index=0&id=ebbe6b1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebbe6b1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
